import {
  ADD_IDLE_FAIL,
  ADD_IDLE_REQUEST,
  ADD_IDLE_SUCCESS,
  ADD_IDLE_TIME_LIMIT_FAIL,
  ADD_IDLE_TIME_LIMIT_REQUEST,
  ADD_IDLE_TIME_LIMIT_SUCCESS,
  ADD_SCREENSHOT_LIMIT_FAIL,
  ADD_SCREENSHOT_LIMIT_REQUEST,
  ADD_SCREENSHOT_LIMIT_SUCCESS,
  ADD_TIMEHERO_FAIL,
  ADD_TIMEHERO_REQUEST,
  ADD_TIMEHERO_SUCCESS,
  ADD_WEEKLY_LIMIT_FAIL,
  ADD_WEEKLY_LIMIT_REQUEST,
  ADD_WEEKLY_LIMIT_SUCCESS,
  ADD_NOTIFICATION_FAIL,
  ADD_NOTIFICATION_REQUEST,
  ADD_NOTIFICATION_SUCCESS,
  GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL,
  GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST,
  GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS,
  ADD_APP_TRACK_IN_MANAGER_FAIL,
  ADD_APP_TRACK_IN_MANAGER_REQUEST,
  ADD_APP_TRACK_IN_MANAGER_SUCCESS,
  GET_COMPANY_SETTING_FAIL,
  GET_COMPANY_SETTING_REQUEST,
  GET_COMPANY_SETTING_SUCCESS,
} from "../../types/manager/settingType";

export const idleSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_IDLE_REQUEST:
      return {
        ...state,
        idleLoading: true,
      };
    case ADD_IDLE_SUCCESS:
      return {
        ...state,
        idleLoading: false,
        idleInfo: payload,
        idleError: "",
      };
    case ADD_IDLE_FAIL:
      return {
        ...state,
        idleLoading: false,
        idleError: payload,
        idleInfo: [],
      };
    default:
      return state;
  }
};

export const idleTimeSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_IDLE_TIME_LIMIT_REQUEST:
      return {
        ...state,
        idleTimeLoading: true,
      };
    case ADD_IDLE_TIME_LIMIT_SUCCESS:
      return {
        ...state,
        idleTimeLoading: false,
        idleTimeInfo: payload,
        idleTimeError: "",
      };
    case ADD_IDLE_TIME_LIMIT_FAIL:
      return {
        ...state,
        idleTimeLoading: false,
        idleTimeError: payload,
        idleTimeInfo: [],
      };
    default:
      return state;
  }
};

export const screenshotLimitSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_SCREENSHOT_LIMIT_REQUEST:
      return {
        ...state,
        screenshotLimitLoading: true,
      };
    case ADD_SCREENSHOT_LIMIT_SUCCESS:
      return {
        ...state,
        screenshotLimitLoading: false,
        screenshotLimitInfo: payload,
        screenshotLimitError: "",
      };
    case ADD_SCREENSHOT_LIMIT_FAIL:
      return {
        ...state,
        screenshotLimitLoading: false,
        screenshotLimitError: payload,
        screenshotLimitInfo: [],
      };
    default:
      return state;
  }
};

export const weeklyLimitSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_WEEKLY_LIMIT_REQUEST:
      return {
        ...state,
        weeklyLimitLoading: true,
      };
    case ADD_WEEKLY_LIMIT_SUCCESS:
      return {
        ...state,
        weeklyLimitLoading: false,
        weeklyLimitInfo: payload,
        weeklyLimitError: "",
      };
    case ADD_WEEKLY_LIMIT_FAIL:
      return {
        ...state,
        weeklyLimitLoading: false,
        weeklyLimitError: payload,
        weeklyLimitInfo: [],
      };
    default:
      return state;
  }
};

export const notificationSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_NOTIFICATION_REQUEST:
      return {
        ...state,
        notifyLoading: true,
      };
    case ADD_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifyLoading: false,
        notifyInfo: payload,
        notifyError: "",
      };
    case ADD_NOTIFICATION_FAIL:
      return {
        ...state,
        notifyLoading: false,
        notifyError: payload,
        notifyInfo: [],
      };
    default:
      return state;
  }
};

export const getDepSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST:
      return {
        ...state,
        getCompSettingLoading: true,
      };
    case GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS:
      return {
        ...state,
        getCompSettingLoading: false,
        getCompSettingInfo: payload,
        getCompSettingError: "",
      };
    case GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL:
      return {
        ...state,
        getCompSettingLoading: false,
        getCompSettingError: payload,
        getCompSettingInfo: [],
      };
    default:
      return state;
  }
};

export const timeHeroSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_TIMEHERO_REQUEST:
      return {
        ...state,
        timeHeroSettingLoading: true,
      };
    case ADD_TIMEHERO_SUCCESS:
      return {
        ...state,
        timeHeroSettingLoading: false,
        timeHeroSettingInfo: payload,
        timeHeroSettingError: "",
      };
    case ADD_TIMEHERO_FAIL:
      return {
        ...state,
        timeHeroSettingLoading: false,
        timeHeroSettingError: payload,
        timeHeroSettingInfo: [],
      };
    default:
      return state;
  }
};

export const appTrackingSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_APP_TRACK_IN_MANAGER_REQUEST:
      return {
        ...state,
        appSettingLoading: true,
      };
    case ADD_APP_TRACK_IN_MANAGER_SUCCESS:
      return {
        ...state,
        appSettingLoading: false,
        appSettingInfo: payload,
        appSettingError: "",
      };
    case ADD_APP_TRACK_IN_MANAGER_FAIL:
      return {
        ...state,
        appSettingLoading: false,
        appSettingError: payload,
        appSettingInfo: [],
      };
    default:
      return state;
  }
};

export const getCompanyByPayloadSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_COMPANY_SETTING_REQUEST:
      return {
        ...state,
        getCompSetLoading: true,
      };
    case GET_COMPANY_SETTING_SUCCESS:
      return {
        ...state,
        getCompSetLoading: false,
        getCompSetInfo: payload,
        getCompSetError: "",
      };
    case GET_COMPANY_SETTING_FAIL:
      return {
        ...state,
        getCompSetLoading: false,
        getCompSetError: payload,
        getCompSetInfo: [],
      };
    default:
      return state;
  }
};
